/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SenderEnum } from './senderEnum';
import { AttachmentInfo } from './attachmentInfo';
import { MailUser } from './mailUser';


/**
 * Message
 */
export interface Mail { 
    /**
     * id
     */
    id?: number;
    /**
     * Message send time
     */
    postDate?: string;
    /**
     * readed
     */
    readed?: boolean;
    /**
     * readed by client
     */
    readedByClient?: boolean;
    /**
     * Attachments infos
     */
    attachments?: Array<AttachmentInfo> | null;
    /**
     * Message
     */
    message?: string | null;
    sender?: MailUser;
    senderType?: SenderEnum;
    /**
     * Theme id
     */
    themeId?: number;
}

